import template from './template.html';
import blockBase from "../../mixins/blockBase";
import 'slick-carousel';

export default {
    name: 'testimonials',
    template: template,
    mixins: [
        blockBase,
    ],
    computed: {
        fields() {
            return this.$store.getters.getAcfOptionField('testimonials');
        }
    },
    mounted() {
        let vm = this;
        $(document).ready(function() {
            setTimeout(function () {
                $(vm.$refs.carousel).slick({
                    arrows: false,
                    fade: true,
                    appendDots: '.js-testimonials-list-carousel-dots',
                    dots: true
                });
            }, 2000);
        });
    }
};